<template>
  <div>
    <v-list-item-title @click="logout" v-if="isPortal">
      Logout
    </v-list-item-title>
    <v-btn text @click="logout" v-else>
      Logout
    </v-btn>
  </div>
</template>

<script>
import {mapState} from 'vuex';
    export default {
        name: "Logout",
        props: ['isPortal'],
        computed: {
            ...mapState('auth', [
                'adminMode'
            ]),
            ...mapState('settings', [
                'companyKey'
            ])
        },
        methods: {
            logout() {
                let p = null;
                let key = this.companyKey;

                if (this.adminMode) {
                    p = this.$store.dispatch('auth/logoutAdmin')
                }else {
                    p = this.$store.dispatch('auth/logout');
                }

                p.then(() => {
                    this.$router.push({path: `/login/${key}`})

                })
                // clean user data when redirect to login so we can't unload in-session data without template errors
            }
        }
    }
</script>
